import { AgChartLegendDoubleClickEvent } from 'ag-charts-enterprise';

export const disableLegendDoubleClick: (
  event: AgChartLegendDoubleClickEvent,
) => void = (event) => {
  event.preventDefault();
};
